export default __webpack_public_path__ + "static/media/fk.544e42fb.svg";